module.exports = __webpack_public_path__ + "img/security.58812afd.png";